import { MultiEmailInputV2, CustomButton, CustomInput, RadioGroup } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useBillingQuestions } from './useBillingQuestions';
import SEND_REQUEST from '../submitARequest.constants';
import type { BillingQuestionsProps } from './billingQuestions.types';
import './styles.scss';

const billingQuestionsList = [
  {
    label: t`I want to pay my bill.`,
    value: 'I want to pay my bill.',
  },
  {
    label: t`I have inquiries about my invoice.`,
    value: 'I have inquiries about my invoice.',
  },
  {
    label: t`My account is on hold.`,
    value: 'My account is on hold.',
  },
  {
    label: t`Other`,
    value: 'Other',
  },
];

const BillingQuestions = ({
  category,
  selectedFacility,
  setLoadingPage,
  backToPrevious,
}: BillingQuestionsProps) => {
  const { state, onChange, onClickSendMessage, onChangeEmailList, onInputChange } =
    useBillingQuestions({ category, selectedFacility, setLoadingPage, backToPrevious });

  return (
    <div className="billing-questions">
      <span className="big-title">{t`Request information`}</span>
      <div className="billing-questions-box">
        <span className="small-title">{t`Billing issue`}</span>
        <div className="billing-list">
          <RadioGroup
            name="selectedBillingQuestion"
            onChange={onChange}
            options={billingQuestionsList}
            value={state.selectedBillingQuestion}
            size="middle"
          />
        </div>
      </div>

      <div className="message-box">
        <span className="small-title">Message</span>
        <CustomInput
          className="message-text"
          placeholder={t`Enter your message`}
          type="textarea"
          value={state.message}
          onChange={onChange}
          name="message"
          allowClear={false}
        />
      </div>

      <div className="email-box">
        <span className="big-title">{t`Notification email`}</span>
        <MultiEmailInputV2
          emailList={state.emailList}
          emailInputValue={state.emailInputValue}
          onChangeEmailList={onChangeEmailList}
          onInputChange={onInputChange}
          isError={!_.isEmpty(state.errorObject.invalidEmails)}
          errorMessage={state.errorObject.invalidEmails}
        />
      </div>

      <div className="bottom-button-row">
        <CustomButton
          id="submit-btn"
          className="button-submit"
          disabled={
            (_.isEmpty(state.emailList) && !state.emailInputValue) ||
            !state.message ||
            !state.selectedBillingQuestion ||
            state.isSaving
          }
          // loading={state.isSaving}
          onClick={() => setTimeout(onClickSendMessage, 100)}
        >
          {SEND_REQUEST}
        </CustomButton>
      </div>
    </div>
  );
};

export default BillingQuestions;
